<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title>确认删除</v-card-title>
      <v-card-text>
        <div>您确定要删除以下课件吗？</div>
        <div><strong>学员名称:</strong> {{ memberName }}</div>
        <div><strong>课件名称:</strong> {{ filename }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">取消</v-btn>
        <v-btn color="red" text @click="confirmDelete">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { coursewareApi } from '@/api/courseware'

export default {
  name: 'DeleteCoursewareConfirmationPopup',

  data() {
    return {
      dialog: false,
      memberName: null,
      coursewareId: null,
      filename: null,
    }
  },

  methods: {
    open(memberName, coursewareId, filename) {
      this.memberName = memberName;
      this.coursewareId = coursewareId;
      this.filename = filename;
      this.dialog = true;
    },

    close() {
      this.memberName = null;
      this.coursewareId = null;
      this.filename = null;
      this.dialog = false;
    },

    async confirmDelete() {
      try {
        await coursewareApi.deleteCourseware(this.coursewareId);
        this.$emit('courseware-deleted');
        this.close();
        this.$toast.success('课件删除成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('删除失败：' + errorMessage);
      }
    }
  }
}
</script> 